import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './assets/css/style.css';
import { getDataForRoute } from './Site/Services/fetchRouteData';

const initializeApp = async () => {
  const _url = window.location.pathname.substring(1);
  const data = await getDataForRoute(_url);

  hydrateRoot(
    document.getElementById('root') as HTMLElement,
    <HelmetProvider>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true
        }}>
        <App initialData={data} initialUrl={_url}/>
      </BrowserRouter>
    </HelmetProvider>
  );
};

initializeApp();
